module.exports = __webpack_public_path__ + "static/img/10009 (2).a1b8323.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10009 (2).webp
// module id = 6xlS
// module chunks = 14